namespace Serenity {
    export interface ServiceLookupEditorOptions extends Select2EditorOptions {
        service?: string;
        idField: string;
        textField: string;
        pageSize?: number;
        minimumResultsForSearch?: any;
        sort?: string[];
        columnSelection?: Serenity.ColumnSelection;
        includeColumns?: string[];
        excludeColumns?: string[];
        includeDeleted?: boolean;
        containsField?: string;
        equalityFilter?: any;
        criteria?: any[];
    }

    @Serenity.Decorators.registerEditor("Serenity.ServiceLookupEditorBase", [ISetEditValue])
    // @Serenity.Decorators.registerEditor("Serenity.ServiceLookupEditorBase")
    export class ServiceLookupEditorBase<TOptions extends ServiceLookupEditorOptions, TItem> extends Select2Editor<TOptions, TItem> {
        constructor(input: JQuery, opt?: TOptions) {
            super(input, opt);
        }

        protected getDialogTypeKey() {
            const dialogTypeKey = super.getDialogTypeKey();

            if (dialogTypeKey) {
                return dialogTypeKey;
            }

            let service = this.getService();

            // @ts-ignore
            if (service.startsWith("~/Services/")) {
                service = service.substr("~/Services/".length);
            }

            if (service.split("/").length === 3) {
                service = service.substr(0, service.lastIndexOf("/"));
            }

            return service.replace("/", ".");
        }

        protected getService(): string {
            return this.options.service;
        }

        protected getServiceUrl() {
            let url = this.getService();

            if (!url) {
                throw new Error("ServiceLookupEditor requires 'service' option to be configured!");
            }

            // @ts-ignore
            if (!url.startsWith("~") && !url.startsWith("/") && url.indexOf("://") < 0) {
                url = `~/Services/${url}`;
            }

            // @ts-ignore
            if (url.startsWith("~")) {
                url = Q.resolveUrl(url);
            }

            return url;
        }

        protected getIncludeColumns() {
            var include = this.options.includeColumns || [],
                idField = this.getIdField();

            if (idField && include.indexOf(idField) < 0) {
                include.push(idField);
            }

            var textField = this.getTextField();

            if (textField && include.indexOf(textField) < 0) {
                include.push(textField);
            }

            return include;
        }

        protected getSort() {
            return this.options.sort || ((this.getTextField()) ? [this.getTextField()] : null);
        }

        protected getCascadeCriteria(): any[] {
            var val = this.get_cascadeValue();

            if (val == null || val === "") {
                if (!Q.isEmptyOrNull(this.get_cascadeField())) {
                    return ["1", "=", "0"];
                }

                return null;
            }

            var fld = this.get_cascadeField();

            return [[fld], "=", val];
        }

        protected getFilterCriteria(): any[] {
            var val = this.get_filterValue();

            if (val == null || val === "") {
                return null;
            }

            var fld = this.get_filterField();

            return [[fld], "=", val];
        }

        protected getIdListCriteria(idList: any[]): any[] {
            if (idList == null) {
                return null;
            }

            if (idList.length == 0) {
                return ["0", "=", "1"];
            }

            var idField = this.getIdField();

            if (idField == null) {
                throw new Error("ServiceLookupEditor requires 'idField' option to be configured!");
            }

            return [[idField], "in", [idList]];
        }

        protected getCriteria(query: Select2SearchQuery): any[] {
            return Serenity.Criteria.and(
                Serenity.Criteria.and(this.getIdListCriteria(query.idList), this.options.criteria),
                Serenity.Criteria.and(this.getCascadeCriteria(), this.getFilterCriteria()));
        }

        protected getListRequest(query: Select2SearchQuery): ListRequest {
            let request: Serenity.ListRequest = {};

            if (query.searchTerm) {
                request.ContainsText = query.searchTerm;
            }

            request.Sort = this.getSort();
            request.ColumnSelection = this.options.columnSelection || Serenity.ColumnSelection.KeyOnly;
            request.IncludeColumns = this.getIncludeColumns();
            request.ExcludeColumns = this.options.excludeColumns;
            request.ContainsField = this.options.containsField;
            request.EqualityFilter = this.options.equalityFilter;
            request.Criteria = this.getCriteria(query);
            request.Skip = query.skip || 0;
            request.Take = (query.take) ? ((query.checkMore) ? query.take + 1 : query.take) : 0;
            request.IncludeDeleted = this.options.includeDeleted;
            request.ExcludeTotalCount = true;

            return request;
        }

        protected getServiceCallOptions(query: Select2SearchQuery, results: (result: Select2SearchResult<TItem>) => void): ServiceOptions<ListResponse<TItem>> {
            return {
                blockUI: false,
                url: this.getServiceUrl(),
                request: this.getListRequest(query),
                onSuccess: response => {
                    var items = response.Entities || [];

                    if (items && query.take && query.checkMore && response.Entities.length > items.length) {
                        items = items.slice(0, query.take);
                    }

                    results({
                        items: items.slice(0, query.take),
                        more: query.checkMore && query.take && items.length > query.take,
                    });
                }
            };
        }

        protected hasAsyncSource() {
            return true;
        }

        protected asyncSearch(query: Select2SearchQuery, results: (result: Select2SearchResult<TItem>) => void): Select2SearchPromise {
            const opt = this.getServiceCallOptions(query, results);

            return Q.serviceCall(opt);
        }

        getEditValue(property: PropertyItem, target: any) {
            super.getEditValue(property, target);

            var data = <TItem>this.element.select2('data');
            if (data)
                target[`${property.name}_Name`] = this.itemText(data);
        }
        getTextValue(): string {
            var data = <TItem>this.element.select2('data');
            return this.itemText(data);
        }
        getSelectedData(): TItem {
            return <TItem>this.element.select2('data');
        }
        setEditValue(source: object, property: PropertyItem) {
            const val = source[property.name];

            if (Array.isArray(val)) {
                this.set_values(val);

                // if () {
                // }
            } else {
                if (val == null) {
                    this.set_value(null);
                } else {
                    this.set_value(val.toString());
                    var textValue = source[`${property.name}_Name`];
                    if (!textValue) {
                        let request: Serenity.ListRequest = {};
                        request.IncludeColumns = this.getIncludeColumns();
                        request.Skip = 0;
                        request.Take = 1;
                        request.ExcludeTotalCount = true;
                        request.EqualityFilter = {};
                        request.EqualityFilter[this.getIdField()] = val;

                        var options = {
                            blockUI: true,
                            url: this.getServiceUrl(),
                            request: request,
                            onSuccess: (response: { Entities: any[] }) => {
                                if (response.Entities && response.Entities.length == 1) {
                                    this.element.select2("data", response.Entities[0]);
                                }
                                else {
                                    this.set_value(null);
                                }
                            }
                        }
                        Q.serviceCall(options);
                        textValue = '....';
                    }

                    let data = {
                        [this.getIdField()]: val,
                        [this.getTextField()]: textValue || "",
                    };

                    // @ts-ignore
                    if (!(this instanceof Vit.CombogridEditor)) {
                        data = super.mapItem(data as any);
                    } else {
                        // @ts-ignore
                        data.source = $.extend({}, data);
                        // @ts-ignore
                        data.disabled = super.itemDisabled(data);
                    }

                    this.element.select2("data", data);
                    this.element.data("select2").setPlaceholder();
                }
            }
        }
    }

    @Decorators.registerEditor("Serenity.ServiceLookupEditor")
    export class ServiceLookupEditor extends ServiceLookupEditorBase<ServiceLookupEditorOptions, any> {
        constructor(hidden: JQuery, opt?: ServiceLookupEditorOptions) {
            super(hidden, opt);
        }
    }
}